import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIStore {
  theme: 'light' | 'dark';
  expandedSections: Record<string, boolean>;
  showShortcutsHelp: boolean;
  toggleTheme: () => void;
  toggleSection: (section: string) => void;
  setShowShortcutsHelp: (show: boolean) => void;
}

export const useUIStore = create<UIStore>()(
  persist(
    (set) => ({
      theme: 'light',
      expandedSections: {},
      showShortcutsHelp: false,

      toggleTheme: () =>
        set((state) => ({
          theme: state.theme === 'light' ? 'dark' : 'light',
        })),

      toggleSection: (section: string) =>
        set((state) => ({
          expandedSections: {
            ...state.expandedSections,
            [section]: !state.expandedSections[section],
          },
        })),

      setShowShortcutsHelp: (show: boolean) =>
        set({ showShortcutsHelp: show }),
    }),
    {
      name: 'broiler_ui_preferences',
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);
